import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.isModalVisible = false
    this.pageLoadTime = Date.now()
    this.hasScrolled = false
    this.hasStayed = false

    this.detectPopstate = this.showModal.bind(this)
    window.addEventListener('popstate', this.detectPopstate)

    this.boundVisibilityChange = this.showModal.bind(this)
    document.addEventListener('visibilitychange', this.boundVisibilityChange)

    this.boundScrollHandler = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.boundScrollHandler)

    this.stayTimer = setTimeout(() => {
      this.hasStayed = true
    }, 30000)
  }
  
  disconnect() {
    window.removeEventListener('popstate', this.detectPopstate)
    document.removeEventListener('visibilitychange', this.boundVisibilityChange)
    window.removeEventListener('scroll', this.boundScrollHandler)
    if (this.stayTimer) {
      clearTimeout(this.stayTimer)
    }
  }

  showModal() {
    if (this.isModalVisible) {
      return
    }

    // Cookieを確認してモーダル表示を制御
    if (this.shouldSuppressModal()) {
      return
    }

    // 新しい条件をチェック（滞在時間とスクロール）
    if (!this.shouldShowModal()) {
      return
    }

    history.pushState(null, '', location.href)

    this.isModalVisible = true
    this.element.classList.remove('is-hidden')
    
    document.body.style.overflow = 'hidden'
  }

  handleScroll() {
    if (this.hasScrolled) {
      return
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const documentHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
    const scrollPercentage = (scrollTop / documentHeight) * 100

    if (scrollPercentage >= 50) {
      this.hasScrolled = true
    }
  }

  shouldShowModal() {
    return this.hasStayed && this.hasScrolled
  }

  closeModal() {
    this.isModalVisible = false
    this.element.classList.add('is-hidden')
    document.body.style.overflow = ''
  }

  go(event) {
    event.preventDefault()
    this.setCookie('line_modal_suppressed', 'true', 30)

    window.open(this.urlValue, '_blank')
    this.closeModal()
  }

  close(event) {
    event.preventDefault()
    if (!this.isModalVisible) {
      return
    }

    this.setCookie('line_modal_suppressed', 'true', 3)
    this.closeModal()
  }

  shouldSuppressModal() {
    const suppressedCookie = this.getCookie('line_modal_suppressed')
    return suppressedCookie === 'true'
  }

  setCookie(name, value, days) {
    const expires = new Date()
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000))
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`
  }

  getCookie(name) {
    const nameEQ = name + "="
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }
}
